import React, { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import PolicyAcceptanceModal from './PolicyAcceptanceModal';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, policiesAccepted, acceptPolicies } = useAuth();
  const location = useLocation();
  const [isAcceptingPolicies, setIsAcceptingPolicies] = useState(false);

  if (!isAuthenticated) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (!policiesAccepted) {
    const handleAcceptPolicies = async () => {
      setIsAcceptingPolicies(true);
      try {
        await acceptPolicies();
      } finally {
        setIsAcceptingPolicies(false);
      }
    };

    return <PolicyAcceptanceModal onAccept={handleAcceptPolicies} isLoading={isAcceptingPolicies} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
